import { render, staticRenderFns } from "./materialAttribute-add-or-update.vue?vue&type=template&id=2941f782&scoped=true"
import script from "./materialAttribute-add-or-update.vue?vue&type=script&lang=js"
export * from "./materialAttribute-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./materialAttribute-add-or-update.vue?vue&type=style&index=0&id=2941f782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2941f782",
  null
  
)

export default component.exports